import { Ref } from 'vue'

import { EventScout } from '@collector/sportsapi-client-legacy'
import { sportsApiClient } from '@desktop/globalState/sportsApiClient'
import { useEventId } from '@desktop/views/Relation/composables/useEventId'
import {
  queryOptions,
  useQuery,
  type UndefinedInitialQueryOptionsWithDataTag,
  type UseQueryReturnType,
} from '@tanstack/vue-query'

type EventScoutsQueryKey = readonly ['event', 'scouts', Ref<number>]

type EventScoutsQueryOptions = UndefinedInitialQueryOptionsWithDataTag<
  EventScout[],
  Error,
  EventScout[],
  EventScoutsQueryKey
>

export function eventScoutsQueryOptions(
  eventId: Ref<number>,
): EventScoutsQueryOptions {
  return queryOptions({
    queryKey: ['event', 'scouts', eventId] as const,
    queryFn: async (): Promise<EventScout[]> => {
      const response = await sportsApiClient.Events.Scouts.get(eventId.value)
      return response.api.data.scouts
    },
  })
}

export const useEventScoutsQuery = (
  options?: Omit<EventScoutsQueryOptions, 'queryKey' | 'queryFn'>,
): UseQueryReturnType<EventScout[], Error> => {
  const eventId = useEventId()
  return useQuery<EventScout[], Error, EventScout[], EventScoutsQueryKey>({
    ...eventScoutsQueryOptions(eventId),
    ...options,
  })
}
